import { useMemo, useState } from 'react';
import { isClaudiStickerUnlocked } from '../../../domain';
import type { ClaudiStickerId } from '../../../domain';
import { useAppStore } from '../../store/appStore';
import {
  createStickersScreenModel,
  type StickersScreenProps,
} from './StickersScreenModelScreen';
import { StickersScreenController } from './StickersScreenController';
import { StickersScreenView } from './StickersScreenView';
import { useInfoPopupState } from '../shared/infoPopup/infoPopupState';

export type { StickersScreenProps } from './StickersScreenModelScreen';

export function StickersScreen(props: StickersScreenProps) {
  const infoPopup = useInfoPopupState();
  const [page, setPage] = useState(0);
  const playerEconomy = useAppStore((s) => s.playerEconomy);
  const isStickerUnlocked = useMemo(
    () => (id: ClaudiStickerId) => isClaudiStickerUnlocked(playerEconomy, id),
    [playerEconomy],
  );
  const model = createStickersScreenModel(
    { ...props, isStickerUnlocked },
    {
      ...infoPopup,
      page,
      setPage,
    },
  );
  const controller = new StickersScreenController(model);

  return <StickersScreenView model={model} controller={controller} />;
}
